@if (!reload) {
    <div class="mobiel-template">
        @if (hasHeader()) {
            <div class="mobiel-template__header">
                <div class="canvas-medium">
                    @if (loading) {
                        <mobiel-template-skeleton
                            [subtitle]="subtitle !== undefined"
                            [amount]="amount !== undefined"
                            [primaryAction]="primaryActionLabel !== undefined"
                            [secondaryAction]="secondaryActionLabel !== undefined"
                        >
                        </mobiel-template-skeleton>
                    }
                    @if (!loading) {
                        <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-bottom-2">
                            @if (title) {
                                <div class="ap-flex-1 ap-align-self-end">
                                    <h1>{{ title }}</h1>
                                </div>
                            }
                            @if (!subtitle) {
                                <ap-amount-display
                                    [value]="amount"
                                    [contrast]="amountContrast"
                                    [emphasize]="true"
                                    class="amount-display amount-display--bigger ap-align-self-center"
                                    data-bb="amount-secondary"
                                >
                                </ap-amount-display>
                            }
                        </div>
                        @if (subtitle) {
                            <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-bottom-2 margin-top--1">
                                <div class="ap-flex-1">
                                    <span class="subtitle">{{ subtitle }}</span>
                                </div>
                                <ap-amount-display
                                    [value]="amount"
                                    [contrast]="amountContrast"
                                    [emphasize]="true"
                                    class="amount-display amount-display--bigger"
                                    data-bb="amount-primary"
                                >
                                </ap-amount-display>
                            </div>
                        }
                        @if (secondarySubtitle) {
                            <div class="ap-flex ap-flex-row ap-flex-gap-2 margin-top--2 ap-margin-bottom-sm-2">
                                <div class="ap-flex-1"></div>
                                <div data-bb="secondary-subtitle">
                                    {{ secondarySubtitle }}
                                    @if (secondarySubAmount !== null && secondarySubAmount !== undefined) {
                                        <ap-amount-display
                                            [value]="secondarySubAmount"
                                            class="amount-display"
                                            data-bb="amount-secondary-sub"
                                        >
                                        </ap-amount-display>
                                    }
                                </div>
                            </div>
                        }
                        @if (hasActions()) {
                            <div class="ap-flex ap-flex-gap-2" [ngClass]="buttonsInColumns ? 'ap-flex-column' : 'ap-flex-row'">
                                @if (primaryActionLabel) {
                                    <ap-button
                                        data-bb="primaryAction"
                                        [ngClass]="secondaryActionLabel ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                                        [compact]="true"
                                        (onClick)="doPrimaryAction()"
                                    >
                                        {{ primaryActionLabel }}
                                    </ap-button>
                                }
                                @if (secondaryActionLabel) {
                                    <ap-button
                                        data-bb="secondaryAction"
                                        [ngClass]="primaryActionLabel ? 'ap-flex-basis-sm-50' : 'ap-flex-basis-sm-100'"
                                        [compact]="true"
                                        (onClick)="doSecondaryAction()"
                                    >
                                        {{ secondaryActionLabel }}
                                    </ap-button>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        }
        <div class="mobiel-template__content canvas-mobile">
            <main id="main-content">
                <ng-content></ng-content>
            </main>
        </div>
    </div>
}
